<template>
  <section>
    <div>
      <template v-if="displayChat.join.type === 'text'">
        <div v-html="displayChat.join.content" ></div>
      </template>
      <template v-else-if="displayChat.join.type === 'link'">
        <div class="w-100">
          <div class="text-center">
            <v-btn
              class="mx-auto"
              color="primary"
              tile
              @click="openLink(displayChat.join.content)"
            >
              Click here to join
            </v-btn>
          </div>
        </div>
      </template>
    </div>

  </section>
</template>

<script>

  export default {
    name: 'JoinChatDisplay',
    data() {
      return {
          displayChat: this.chat
      }
    },
    props: {
      chat: {
          type: Object,
          required: true
      }
    },
    watch: {
        chat(newValue) {
            this.displayChat = newValue;
        }
    },
    methods:{
        openLink(link) {
            window.open(link, '_blank')
        }

    },
    async mounted () {
    },
  }
</script>
<style>
 .wiki-quote {
   border-style: solid;
   border-width: 0 0 0 15px;
   border-color: #EF5350 !important;
 }
</style>
